import React from 'react';

const CampaignPhone = ({ name, message }) => {
  return (
    <div className="marvel-device campaign-phone iphone-x">
      <div className="notch">
        <div className="speaker" />
      </div>
      <div className="overflow">
        <div className="shadow shadow--tr" />
        <div className="shadow shadow--tl" />
        <div className="shadow shadow--br" />
        <div className="shadow shadow--bl" />
      </div>
      <div className="inner-shadow" />
      <div className="screen">
        <div className="main-content">
          <div className="contact-list-name text-center">
            <img alt="..." src={require('../../../assets/SidebarIcons/icon-no-pp.png')} />
            <h2 className="py-2">{name}</h2>
          </div>
          {message && (
          <div className="contact-list-message text-center my-3">
            <p>
              <span style={{ wordBreak: 'break-all'}}>{message}</span>
            </p>
          </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CampaignPhone;
